import React from "react";
import { graphql } from "gatsby";
import { LoginForm } from "./LoginForm";
import {
  KontentComponentSettings,
  KontentLinks,
  KontentMultiChoice,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatLoginForms } from "../../../lib/formatLoginForms";

export type LoginFormLabels =
  | "Digital Banking"
  | "E-Business"
  | "Wealth Management"
  | "Loan Portal"
  | "Credit Card"
  | "Custom Sign In";

export type LoginFormTypes =
  | "digital_banking"
  | "e_business"
  | "wealth_management"
  | "loan_portal"
  | "credit_card"
  | "custom_sign_in";

export interface KontentLoginForms {
  value: {
    id: string;
    elements: {
      link_configuration__link: KontentLinks;
      login_method: KontentMultiChoice<LoginFormTypes>;
      offline_message: StringValue;
    };
  }[];
}
interface Props extends KontentComponentSettings {
  login_forms: KontentLoginForms;
}

const LoginFormContainer: React.FC<Props> = ({ login_forms, ...props }) => {
  const componentSettings = getComponentSettings({ ...props });
  const forms = formatLoginForms(login_forms);

  return <LoginForm forms={forms} {...componentSettings}></LoginForm>;
};

export default LoginFormContainer;

export const fragmentLoginFormContainer = graphql`
  fragment LoginForm on kontent_item_login_form {
    elements {
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      login_forms {
        ...loginForms
      }
      component_settings__anchor_name {
        value
      }
    }
  }
`;
